const mvSwiper = new Swiper('.mv-swiper', {
    loop:true,
    lazy: false,
    spaceBetween: 10,
    centeredSlides: true,
    
    // デフォルト設定 (モバイル/SP時: 750px未満)
    direction: 'vertical', // 縦スライド
    slidesPerView: 1,      // 1枚表示
    
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    lazy: {
      loadPrevNext: true,
    },
    autoplay: {
      delay: 5000, // 5秒ごとにスライド
      disableOnInteraction: false,
    },
    
    // ブレークポイント設定 (PC時: 750px以上)
    breakpoints: {
      750: { // 750px以上の場合
        direction: 'horizontal', // 横スライド
        slidesPerView: 'auto',   // 複数枚表示 (ご要望の「画面中央と左右が半分程度見れる」設定)
        spaceBetween: 24,        // PC時のスライド間のスペース (既存の679pxのものを750pxに合わせる)
        navigation: { // 矢印ナビゲーションを追加
          nextEl: '.swiper-mv-button-next',
          prevEl: '.swiper-mv-button-prev',
        },

      }
    },
    
    // CSS調整のための高さを設定 (SPの縦スライドには高さが必要)
    // .mv-slideのheightが100%になるように親要素に高さを設定するか、
    // ここで高さを指定する必要があります。
    // 例として、SPではビューポートの高さ(vh)を使用すると全画面に近くなりますが、
    // 親要素の.mv-swiperに高さを設定するのが一般的です。
    // ここではCSSで対応するため、このオプションは特に触れません。
  });


// スライダーが初期化された後に.loadedクラスを追加
document.addEventListener('DOMContentLoaded', function() {
  document.querySelector('.mv-top-Slider').classList.add('loaded');
});


const bannerSwiper = new Swiper('.top-banner-swiper', { 
    loop:true,
    lazy: false,
    spaceBetween: 18,
    centeredSlides: true,
    
    slidesPerView: 1.3,
    
    // If we need pagination
    pagination: {
      el: '.swiper-pagination', // ページネーション要素もこのコンテナ内にあるか確認
      clickable: true,
    },
    lazy: {
      loadPrevNext: true,
    },
    navigation: {
      nextEl: '.swiper-top-banner-button-next',
      prevEl: '.swiper-top-banner-button-prev',
    },
    
    // ブレークポイント設定 (PC時: 750px以上)
    breakpoints: {
      750: {
        slidesPerView: 5,
        spaceBetween: 50,
      }
    },
  });



  (function () {
  const TARGET_ID = 'collection-products-top';

  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[data-filter-input]');
    if (!a) return;

    // 無効リンクは除外（任意）
    if (a.hasAttribute('data-disabled')) return;

    e.preventDefault();

    // hrefに #TARGET_ID を付与して遷移
    // すでにハッシュがあっても上書き
    const url = new URL(a.href, window.location.origin);
    url.hash = TARGET_ID;

    window.location.href = url.toString();
  });
})();




window.addEventListener('load', function() { document.getElementById('loading-spinner').style.display = 'none'; });